import React, { memo } from "react";
import { cn } from "helpers/style";
import { CONTACT_PHONE_NUMBER } from "constants/variables";
import styles from "./Contacts.module.scss";

type Props = {
  mobileVersion?: boolean;
  contactPhone?: string;
};

const Contacts: React.FC<Props> = ({ mobileVersion, contactPhone }: Props) => {
  if (mobileVersion) {
    return (
      <div className={styles.footerContacts}>
        <span className={styles.footerContactsPhoneContainer}>
          <a href={`tel:${contactPhone ?? CONTACT_PHONE_NUMBER}`}>
            {contactPhone ?? CONTACT_PHONE_NUMBER}
          </a>
        </span>
        <span
          className={cn([
            styles.footerContactsTimeInfo,
            styles.footerContactsTimeInfoSecondary,
          ])}
        >
          Круглосуточно
        </span>
      </div>
    );
  }

  return (
    <div className={styles.footerContacts}>
      Есть вопросы? Звоните{" "}
      <span className={styles.footerContactsPhoneContainer}>
        <span className={styles.footerContactsPhone}>
          <a href={`tel:${contactPhone ?? CONTACT_PHONE_NUMBER}`}>
            {contactPhone ?? CONTACT_PHONE_NUMBER}
          </a>
        </span>
        .
      </span>
      <span className={styles.footerContactsTimeInfo}>
        {" "}
        Режим работы: круглосуточно
      </span>
    </div>
  );
};

export default memo(Contacts);
